<template>
  <v-footer color="white" app inset>
    <v-container class="pa-0">
      <v-layout row wrap justify-space-between>
        <v-flex xs12 sm4 class="text-xs-center" >
          <a v-if="!hidePolicy"
            href="#"
            @click.prevent="$store.dispatch('contracts/openContractDialog', {
              contractName: 'privacy_policy',
              justForInfo: true,
              disableCheckbox: true,
            })">
            {{$tf('PrivacyPolicy')}}
          </a>
        </v-flex>
        <v-flex xs12 :sm4="!hideTerms||!hidePolicy"  class="text-xs-center"><span class="grey--text">{{$tf('CopyrightNotice', {year: new Date().getFullYear()})}}</span></v-flex>
        <v-flex xs12 sm4 class="text-xs-center terms_container" >
          <a v-if="!hideTerms"
            href="#"
            @click.prevent="$store.dispatch('contracts/openContractDialog', {
              contractName: 'terms_and_conditions',
              justForInfo: true,
              disableCheckbox: true,
            })">
            {{$tf('Terms and Conditions')}}
          </a>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'idonia-footer',
    props: {
      hidePolicy: {
        type: Boolean,
        default: false
      },
      hideTerms: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  footer {
    position: static !important;
    height: fit-content !important;
    flex: 0 0 auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/IdoniaFooter.vue